import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import "./subCheckModal.scss";

const SubCheckModal = ({ open, handleClose, parentCheck, agency }) => {
  const [childChecks, setChildChecks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Only fetch child checks when modal is open and we have a parent check
    if (open && parentCheck) {
      const fetchChildChecks = async () => {
        setLoading(true);
        try {
          // Check if the parent has childCheckUrls array
          if (parentCheck.childCheckUrls && parentCheck.childCheckUrls.length > 0) {
            const agencyRigchecksCollectionRef = collection(
              db,
              `Rigchecks/VgTv80ik2BtavT0A5owc/${agency} Rigchecks`
            );
            
            // Create a query to get all child checks for this parent
            const childChecksQuery = query(agencyRigchecksCollectionRef, 
              where("parentCheckId", "==", parentCheck.id),
              where("isChildCheck", "==", true)
            );
            
            const querySnapshot = await getDocs(childChecksQuery);
            const childChecksList = querySnapshot.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));
            
            setChildChecks(childChecksList);
          } else {
            // No child checks available
            setChildChecks([]);
          }
        } catch (error) {
          console.error("Error fetching child checks:", error);
        } finally {
          setLoading(false);
        }
      };
      
      fetchChildChecks();
    }
  }, [open, parentCheck, agency]);

  const handleChildCheckClick = (childCheckId) => {
    // Navigate to the selected child check
    navigate(`/${agency}/${childCheckId}`);
    handleClose();
  };

  const handleParentCheckClick = () => {
    // Navigate to the parent check
    navigate(`/${agency}/${parentCheck.id}`);
    handleClose();
  };

  return (
    <div className={`sub-check-modal ${open ? 'open' : ''}`}>
      <div className="modal-backdrop" onClick={handleClose}></div>
      <div className="modal-content">
        <div className="modal-header">
          <h2>{parentCheck?.name}</h2>
          <button className="close-button" onClick={handleClose}>×</button>
        </div>
        
        <div className="modal-body">
          {loading ? (
            <div className="loading">Loading checks...</div>
          ) : (
            <div className="checks-container">
              <div className="check-list-title">Select a check to complete:</div>
              
              {/* Parent check */}
              {parentCheck && !parentCheck.hidden && (
                <div className="check-item main-check" onClick={handleParentCheckClick}>
                  <div className="check-name">{parentCheck?.name}</div>
                  <div className="check-badge">Main Check</div>
                </div>
              )}
              
              {/* Child checks */}
              {childChecks.length > 0 && (
                <>
                  {childChecks
                    .filter(check => !check.disabled)
                    .map((check) => (
                      <div 
                        key={check.id} 
                        className="check-item sub-check" 
                        onClick={() => handleChildCheckClick(check.id)}
                      >
                        <div className="check-name">{check.name}</div>
                        <div className="check-badge">Sub Check</div>
                      </div>
                    ))}
                </>
              )}
              
              {childChecks.length === 0 && (
                <div className="no-checks-message">
                  No sub-checks available.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubCheckModal;
